$(document).ready(function () {
  function reveal() {
    var reveals = document.querySelectorAll(".reveal");
    var reveals_h = document.querySelectorAll(".reveal_horizont .card_home");

    for (var i = 0; i < reveals.length; i++) {
      var windowHeight = window.innerHeight;
      var elementTop = reveals[i].getBoundingClientRect().top;
      var elementVisible = (windowHeight > 768 ? 150 : 30);

      if (elementTop < windowHeight - elementVisible) {
        setTimeout((e) => {
          e.classList.add("active")
        }, reveals[i].getAttribute('data-reveal-delay') || 0, reveals[i]);
      } else if (elementTop > windowHeight) {
        reveals[i].classList.remove("active");
      }
    }
    for (var i = 0; i < reveals_h.length; i++) {
      var windowHeight_h = window.innerHeight;
      var elementTop_h = reveals_h[i].getBoundingClientRect().top;
      var elementVisible_h = (windowHeight > 768 ? 150 : 30);

      if (elementTop_h < windowHeight_h - elementVisible_h) {
        setTimeout((e) => {
          e.classList.add("active")
        }, reveals_h[i].getAttribute('data-reveal-delay') || 0, reveals_h[i]);
      } else if (elementTop_h > windowHeight_h) {
        reveals_h[i].classList.remove("active");
      }
    }
  }

  function getUrlParams() {
    var params = {};
    var search = window.location.search.substring(1); // Remove the '?'
    if (search) {
      var pairs = search.split('&');
      for (var i = 0; i < pairs.length; i++) {
        var pair = pairs[i].split('=');
        params[pair[0]] = pair[1];
      }
    }
    return params;
  }
  var urlParams = getUrlParams();

  if ("booking_popup" in urlParams) {
    var param = urlParams.booking_popup;
    if(param == '1') {
      console.log('hide popup');
      $("body").addClass("hide_chilipiper_popup");
      $(".open-chilipiper-popup").click(function(){
        $("body").removeClass("hide_chilipiper_popup");
        $(".open-chilipiper-popup").hide();
      });
    }else{
      $(".open-chilipiper-popup").hide();
      console.log('show popup');
    }
  } else {
    $(".open-chilipiper-popup").hide();
  }

  function sticky() {
    var sticky = document.querySelectorAll(".sticky");

    for (var i = 0; i < sticky.length; i++) {
      var windowHeight = window.innerHeight;
      var elementTop = sticky[i].getBoundingClientRect().top;
      var elementVisible = 300;

      if (elementTop < windowHeight - elementVisible) {
        sticky[i].classList.add("active");
      } else {
        sticky[i].classList.remove("active");
      }
    }
  }

  !function (a) {
    a.fn.animatedHeadline = function (e) {
      function n(e) {
        e.each(function () {
          var e = a(this), n = e.text().split(""), s = e.hasClass("is-visible");
          for (i in n)
            e.parents(".rotate-2").length > 0 && (n[i] = "<em>" + n[i] + "</em>"), n[i] = s ? '<i class="in">' + n[i] + "</i>" : "<i>" + n[i] + "</i>";
          var t = n.join("");
          e.html(t).css("opacity", 1)
        })
      }
      function s(a) {
        var i = r(a);
        if (a.parents(".ah-headline").hasClass("type")) {
          var e = a.parent(".ah-words-wrapper");
          e.addClass("selected").removeClass("waiting"), setTimeout(function () {
            e.removeClass("selected"), a.removeClass("is-visible").addClass("is-hidding").delay(500).queue(function (nxt) {
              $(this).removeClass("is-hiding").addClass("is-hidden");
              nxt();
            }).children("i").removeClass("in").addClass("out")
          }, h.selectionDuration), setTimeout(function () {
            t(i, h.typeLettersDelay)
          }, h.typeAnimationDelay)
        } else if (a.parents(".ah-headline").hasClass("letters")) {
          var n = a.children("i").length >= i.children("i").length;
          l(a.find("i").eq(0), a, n, h.lettersDelay), o(i.find("i").eq(0), i, n, h.lettersDelay)
        } else
          a.parents(".ah-headline").hasClass("clip") ? a.parents(".ah-words-wrapper").animate({width: "2px"}, h.revealDuration, function () {
            d(a, i), t(i)
          }) : a.parents(".ah-headline").hasClass("loading-bar") ? (a.parents(".ah-words-wrapper").removeClass("is-loading"), d(a, i), setTimeout(function () {
            s(i)
          }, h.barAnimationDelay), setTimeout(function () {
            a.parents(".ah-words-wrapper").addClass("is-loading")
          }, h.barWaiting)) : (d(a, i), setTimeout(function () {
            s(i)
          }, h.animationDelay))
      }
      function t(a, i) {
        a.parents(".ah-headline").hasClass("type") ? (o(a.find("i").eq(0), a, !1, i), a.addClass("is-visible").removeClass("is-hidden")) : a.parents(".ah-headline").hasClass("clip") && a.parents(".ah-words-wrapper").animate({width: a.width() + 10}, h.revealDuration, function () {
          setTimeout(function () {
            s(a)
          }, h.revealAnimationDelay)
        })
      }
      function l(i, e, n, t) {
        if (i.removeClass("in").addClass("out"), i.is(":last-child") ? n && setTimeout(function () {
          s(r(e))
        }, h.animationDelay) : setTimeout(function () {
          l(i.next(), e, n, t)
        }, t), i.is(":last-child") && a("html").hasClass("no-csstransitions")) {
          var o = r(e);
          d(e, o)
        }
      }
      function o(a, i, e, n) {
        a.addClass("in").removeClass("out"), a.is(":last-child") ? (i.parents(".ah-headline").hasClass("type") && setTimeout(function () {
          i.parents(".ah-words-wrapper").addClass("waiting")
        }, 200), e || setTimeout(function () {
          s(i)
        }, h.animationDelay)) : setTimeout(function () {
          o(a.next(), i, e, n)
        }, n)
      }
      function r(a) {
        return a.is(":last-child") ? a.parent().children().eq(0) : a.next()
      }
      function d(a, i) {
        a.removeClass("is-visible").addClass("is-hiding").delay(500).queue(function (nxt) {
          $(this).removeClass("is-hiding").addClass("is-hidden");
          nxt();
        }), i.removeClass("is-hidden").addClass("is-visible")
      }
      var h = a.extend({animationType: "rotate-1", animationDelay: 2500, barAnimationDelay: 3800, barWaiting: 800, lettersDelay: 50, typeLettersDelay: 150, selectionDuration: 500, typeAnimationDelay: 1300, revealDuration: 600, revealAnimationDelay: 1500}, e), p = h.animationDelay;
      this.each(function () {
        var i = a(this);
        if (h.animationType && ("type" == h.animationType || "rotate-2" == h.animationType || "rotate-3" == h.animationType || "scale" == h.animationType ? i.find(".ah-headline").addClass("letters " + h.animationType) : "clip" == h.animationType ? i.find(".ah-headline").addClass(h.animationType + " is-full-width") : i.find(".ah-headline").addClass(h.animationType)), n(a(".ah-headline.letters").find("b")), i.hasClass("loading-bar"))
          p = h.barAnimationDelay, setTimeout(function () {
            i.find(".ah-words-wrapper").addClass("is-loading")
          }, h.barWaiting);
        else if (i.hasClass("clip")) {
          var e = i.find(".ah-words-wrapper"), t = e.width() + 10;
          e.css("width", t)
        } else if (!i.find(".ah-headline").hasClass("type")) {
          var l = i.find(".ah-words-wrapper b"), o = 0;
          l.each(function () {
            var i = a(this).width();
            i > o && (o = i)
          }), i.find(".ah-words-wrapper").css("width", o)
        }
        setTimeout(function () {
          s(i.find(".is-visible").eq(0))
        }, p)
      })
    }
  }(jQuery);

  $(document).one('scroll', function () {
    $('body').addClass('oncescrolled');
    window.addEventListener("scroll", reveal);
    window.addEventListener("scroll", sticky);
    window.dispatchEvent(new Event('scroll'));

    $(function () {
      $('.animate-slide').animatedHeadline({
        animationType: 'slide'
      });
    });

    function fixSliderLinks(selector) {
      $(selector + '[aria-hidden="true"] a').each(function () {
        $(this).attr('tabindex', '-1');
      });
      $(selector + '[aria-hidden="false"] a').each(function () {
        $(this).removeAttr('tabindex');
      });
    }
    if ($('.scroll-cards').length) {
      $('.scroll-cards').on('init', function () {
        fixSliderLinks('.scroll-cards .slick-slide');
      });
      $('.scroll-cards').on('afterChange', function () {
        fixSliderLinks('.scroll-cards s.slick-slide');
      });
      $('.scroll-cards').on('beforeChange', function (event, slick, currentSlide, nextSlide) {
        $('.scroll-cards').find('img.lazy').each(function () {
          if (!$(this).hasClass('loaded')) {
            $(this).attr('src', $(this).data('src')).addClass('loaded');
            if ($(this).parent()[0].tagName == 'PICTURE') {
              $(this).parent().find('[data-srcset]').each(function () {
                $(this).attr('srcset', $(this).data('srcset'));
              });
            }
          }
        });
      });
      $('.scroll-cards').slick({
        accessibility: false,
        centerMode: false,
        centerPadding: '0',
        slidesToShow: 3.5,
        arrows: false,
        loop: true,
        autoplay: false,
        autoplaySpeed: 3000,
        pauseOnHover: true,
        pauseOnFocus: false,
        cssEase: 'ease-out',
        responsive: [
          {
            breakpoint: 1480,
            settings: {
              centerMode: false,
              centerPadding: '0',
              slidesToShow: 3
            }
          },
          {
            breakpoint: 1280,
            settings: {
              centerMode: false,
              centerPadding: '0',
              slidesToShow: 2
            }
          },
          {
            breakpoint: 850,
            settings: {
              centerMode: true,
              centerPadding: '0',
              slidesToShow: 1
            }
          },
          {
            breakpoint: 320,
            settings: {
              centerMode: true,
              centerPadding: '1',
              slidesToShow: 1
            }
          }
        ]
      });
      $('.left').click(function () {
        $('.scroll-cards').slick('slickPrev');
      })

      $('.right').click(function () {
        $('.scroll-cards').slick('slickNext');
      })
    }

    if ($('#card-view-all').length) {
      $('#card-view-all .scroll-cards_insights').on('init', function () {
        fixSliderLinks('#card-view-all .scroll-cards_insights .slick-slide');
      });
      $('#card-view-all .scroll-cards_insights').on('afterChange', function () {
        fixSliderLinks('#card-view-all .scroll-cards_insights .slick-slide');
      });
      $('#card-view-all .scroll-cards_insights').slick({
        accessibility: false,
        centerMode: false,
        centerPadding: '0',
        slidesToShow: 2,
        arrows: false,
        loop: true,
        autoplay: false,
        autoplaySpeed: 3000,
        pauseOnHover: true,
        pauseOnFocus: false,
        cssEase: 'ease-out',
        responsive: [
          {
            breakpoint: 1280,
            settings: {
              centerMode: false,
              centerPadding: '0',
              slidesToShow: 2
            }
          },
          {
            breakpoint: 660,
            settings: {
              centerMode: true,
              centerPadding: '1',
              slidesToShow: 1
            }
          }
        ]
      });
      $('.left_insights').click(function () {
        $('#card-view-all .scroll-cards_insights').slick('slickPrev');
      })

      $('.right_insights').click(function () {
        $('#card-view-all .scroll-cards_insights').slick('slickNext');
      })
    }
  });
});



